module.exports = __webpack_public_path__ + "img/90.585f41d2.jpg";